import React from 'react';
import { cn } from '@/lib/utils';

const About = () => {
  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div className="reveal">
            <div className="relative">
              <div className="bg-beauty-rose/20 absolute top-0 left-0 w-full h-full rounded-lg transform -rotate-6"></div>
              <div className="bg-beauty-pink/30 absolute top-0 left-0 w-full h-full rounded-lg transform rotate-3"></div>
              <img 
                src="/images/about/founder.jpg" 
                alt="Anjana - Founder" 
                className="relative z-10 w-full h-auto rounded-lg shadow-lg"
              />
            </div>
          </div>
          <div className="reveal-right">
            <div className="max-w-lg">
              <h2 className="text-3xl md:text-4xl font-bold text-beauty-rose mb-6">The Anjana Story</h2>
              <p className="mb-4 text-gray-600">
                Welcome to Anjana Beauty Care, where beauty meets expertise and personal care. 
                Founded by Alka Bhalara with over 30 years of experience in the beauty industry, 
                our salon is dedicated to enhancing your natural beauty.
              </p>
              <p className="mb-4 text-gray-600">
                What started as a passionate pursuit in a small corner of Vadodara has now 
                evolved into a premium beauty destination trusted by women of all ages. 
                Alka's philosophy combines traditional beauty wisdom with modern techniques, 
                creating an experience that is both timeless and contemporary.
              </p>
              <p className="mb-6 text-gray-600">
                Our team of skilled professionals are trained not just in beauty techniques 
                but also in understanding your unique needs. We believe every client deserves 
                personalized attention and care that makes them feel special.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 items-center">
                <div className="flex flex-col items-center">
                  <span className="text-3xl font-playfair font-bold text-beauty-rose">30+</span>
                  <span className="text-sm text-gray-500">Years Experience</span>
                </div>
                <div className={cn(
                  "w-px h-12 bg-gray-300",
                  "hidden sm:block"
                )}></div>
                <div className="flex flex-col items-center">
                  <span className="text-3xl font-playfair font-bold text-beauty-rose">10,000+</span>
                  <span className="text-sm text-gray-500">Happy Clients</span>
                </div>
                <div className={cn(
                  "w-px h-12 bg-gray-300",
                  "hidden sm:block"
                )}></div>
                <div className="flex flex-col items-center">
                  <span className="text-3xl font-playfair font-bold text-beauty-rose">100%</span>
                  <span className="text-sm text-gray-500">Satisfaction</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
